export default "__VITE_ASSET__TFNs_RLP__"